import React from "react";
import buttonStyles from "../styles/Button.module.scss";
import loader from '../public/anim/loader';


const lottieOptions = {
  loop: true,
  autoplay: true,
  animationData: loader,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};


function CustomButton(props) {
  return (
    <div
      className={
        props.animatedWhite
          ? buttonStyles.animatedWhite
          : props.animatedColor
            ? buttonStyles.animatedColor
            : props.animatedGradient
              ? buttonStyles.animatedGradient
              : buttonStyles.button
      }
      style={{
        opacity: props.disabled ? 0.4 : 1,
        pointerEvents: props.disabled ? 'none' : 'auto',
        borderColor: props.borderColor,
        borderWidth: props.borderColor ? "2px" : 0,
        borderStyle: "solid",
        backgroundColor: props.backgroundColor ? props.backgroundColor : "none"
      }}
      onClick={() => props.handleClick()}
    >

      {props.icon && !props.iconRight && (
        <img
          src={props.icon}
          className={buttonStyles.icon}
          style={{ marginRight: "15px", opacity: props.loading ? 0 : 1 }}
          alt="icone flêche"
        />
      )}
      <div className={buttonStyles.label} style={{ color: props.textColor, opacity: props.loading ? 0 : 1 }}>
        {props.label}
      </div>
      {props.icon && props.iconRight && (
        <img
          src={props.icon}
          className={buttonStyles.icon}
          style={{ marginLeft: "15px", opacity: props.loading ? 0 : 1 }}
          alt="logo flêche"
        />
      )}


      {props.loading && (
        <div className={buttonStyles.buttonLoader}>
          Envoi...
        </div>)}
    </div>
  );
}

export default CustomButton;
